import { Box, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import React from "react";

export default function IconTitle({ title, subtitle, icon }) {
  const { palette, breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));
  return (
    <Box style={{ textAlign: "center" }} mb={isScreenXs ? 1 : 3}>
      {/* {icon} */}
      <Typography
        style={{ color: palette.text.title }}
        variant={isScreenXs ? "subtitle1" : "h5"}
      >
        <strong>{title}</strong>
      </Typography>
      {subtitle && (
        <Typography
          color="primary"
          style={{
            lineHeight: 1.3,
            padding: "8px 16px 0",
          }}
          variant={isScreenXs ? "subtitle2" : "subtitle1"}
        >
          <strong>{subtitle}</strong>
        </Typography>
      )}
    </Box>
  );
}
